import { useState } from "react";
import useSeo from "@/hooks/useSeo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHero from "@/components/feature/PageHero";
import { faqs } from "@/mocks/doujinshi";

const faqLdJson = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export default function Faq() {
  useSeo({
    title: "常见问题 | 同人志分类、配对推荐与选书指南",
    description:
      "同人志指南常见问题解答：什么是同人志、百合与耽美的区别、如何快速找到喜欢的同人作品、CP配对推荐与榜单区别等，帮你快速上手。",
    path: "/faq",
  });

  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="bg-background-50">
      <Navbar />
      <PageHero
        eyebrow="FAQ"
        title="常见问题"
        desc="关于同人志、分类方式、配对推荐与选书建议的常见疑问，在这里快速找到答案。"
        crumbs={[{ label: "常见问题" }]}
      />

      <section className="mx-auto max-w-3xl px-4 py-14 md:px-6 md:py-16">
        <div className="space-y-3">
          {faqs.map((item, i) => (
            <div key={item.q} className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <button
                type="button"
                onClick={() => setOpen(open === i ? null : i)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                aria-expanded={open === i}
              >
                <span className="text-sm font-medium text-foreground-900 md:text-base">{item.q}</span>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className={`ri-${open === i ? "subtract" : "add"}-line`}></i>
                </span>
              </button>
              {open === i && (
                <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* JSON-LD 结构化数据 */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: faqLdJson }} />

      <Footer />
    </div>
  );
}